import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
// import { useOutlet } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { useAuth } from '../../hooks/useAuth';
import { getRoute, ROUTE_ENUMS } from '../../helpers/routes';

const ProtectedDashboardLayout = ({ t }) => {
	// const outlet = useOutlet();
	const navigate = useNavigate();
	const { authStep, checkAuthStatus, isAuthenticated } = useAuth();

	useEffect(() => {
		checkAuthStatus();
	}, []);

	useEffect(() => {
		if (authStep === null && !isAuthenticated) {
			navigate(getRoute(ROUTE_ENUMS.LOGIN), { replace: true });
		}
	}, [authStep, isAuthenticated]);

	return <p>Help</p>;
};

ProtectedDashboardLayout.propTypes = {
	t: PropTypes.func
};

export default withTranslation('layouts', {
	keyPrefix: 'protectedDashboard'
})(ProtectedDashboardLayout);
